// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4974":"8ef59a06","5954":"33e3fce6","6185":"8ef59a06","8041":"8ef59a06"}[chunkId] + ".chunk.css";
};